import {
  Box,
  Button,
  Container,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { DropDownList } from "../Components/DropDownList";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { DialogAlert } from "../Components/DialogAlert";
import { useAuth } from "../Components/AuthContext";
import Select from "react-select";
import { instance } from "../Components/config";
import { LoaderBox } from "../Components/LoaderBox";

function RptProductosMenu() {
  const [catalogo, setCatalogo] = useState({ Id: "", Nombre: "" });
  const [producto, setProducto] = useState({ Id: "", Nombre: "" });
  const [isLoading, setLoading] = useState(true);
  const [mes, setMes] = useState([]);
  const [meses, setMeses] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const { user } = useAuth();
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
    redirect: false,
    page: "/Actividad",
    pageState: {},
  });
  const navigate = useNavigate();

  async function getItems() {
    await instance
      .get("localidad/listMeses")
      .then((res) => {
        setMeses(
          res.data.map((item) => {
            return { label: item.Nombre, value: item.Id };
          })
        );
        setLoading(false);
      })
      .catch((error) => {})
      .finally();
  }
  if (isLoading) {
    getItems();
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let mesesList = "";
    let mesesLabels = "";
    mes.forEach((i) => {
      mesesList += mesesList === "" ? `${i.value}` : `,${i.value}`;
      mesesLabels += mesesLabels === "" ? `${i.label}` : `, ${i.label}`;
    });
    const info = e.target;
    let form = {
      id: user.id,
      catalogo: catalogo.Id,
      producto: producto.Id,
      anio: info.anio.value,
      cooperacion: info.cooperacion.value,
      meses: mesesList,
    };
    instance
      .post("reporte/producto", form)
      .then((res) => {
        navigate("/RptProductos", {
          state: {
            data: res.data,
            header: `${catalogo.Nombre} 
            ${producto.Id === "" ? "" : ", Producto: " + producto.Nombre}
            ${info.anio.value === "" ? "" : ", Año: " + info.anio.value}
            ${
              info.cooperacion.value === ""
                ? ""
                : ", Cooperación: " +
                  (info.cooperacion.value === "true" ? "Sí" : "No")
            }`,
            meses: `
            ${mesesLabels === "" ? "" : "Meses: " + mesesLabels}`,
          },
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };

  return (
    <LoaderBox isLoading={isLoading}>
      <Container
        maxWidth="sm"
        sx={{
          border: { xs: "0", sm: "1px solid #000" },
          mt: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 2,
        }}
        component="form"
        onSubmit={handleSubmit}
      >
        <Typography variant="h5" sx={{ textDecoration: "underline" }}>
          Reporte por productos
        </Typography>
        <Grid container spacing={2}>
          <Grid container spacing={3} padding={2} rowSpacing={1}>
            <Grid item xs={12}>
              <DropDownList
                required
                title="Catálogo"
                endpoint={"/catalogo/listAll"}
                selectedItem={catalogo}
                setSelectedItem={setCatalogo}
              />
            </Grid>
            <Grid item xs={12}>
              <DropDownList
                required
                title="Producto"
                endpoint={
                  catalogo.Id !== ""
                    ? `/producto/listAllByCatalogo/${catalogo.Id}`
                    : undefined
                }
                selectedItem={producto}
                setSelectedItem={setProducto}
                disabled={catalogo.Id === ""}
                hierarchyUpdated={catalogo}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              views={["year"]}
              margin="standard"
              fullWidth
              id="anio"
              label="Año que planifica"
              name="anio"
              format="YYYY"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <FormControl>
                <FormLabel>Cooperación Externa</FormLabel>
                <RadioGroup row name="cooperacion">
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label="Sí"
                  />
                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Select
              options={meses}
              isMulti
              name="meses"
              id="meses"
              placeholder="Meses"
              className="basic-multi-select"
              classNamePrefix="select"
              onChange={(choice) => setMes(choice)}
            />
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                type="submit"
                size="large"
                variant="contained"
                color="success"
                padding={1}
              >
                Generar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}
export { RptProductosMenu };
